import React from 'react';
import { Box, Paper, Stack, Skeleton, Grid, Card, CardContent } from '@mui/material';

const SkeletonLoader = ({ variant = 'list', count = 5 }) => {
  if (variant === 'list') {
    return (
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: { xs: 1.5, sm: 2 },
        }}
      >
        {Array.from({ length: count }).map((_, index) => (
          <Paper
            key={index}
            variant="outlined"
            sx={{
              p: { xs: 2, sm: 2.4 },
              borderRadius: 2,
              borderColor: 'divider'
            }}
          >
            <Stack 
              direction={{ xs: 'column', md: 'row' }} 
              spacing={2} 
              alignItems={{ xs: 'stretch', md: 'flex-start' }} 
              justifyContent="space-between" 
              flexWrap="nowrap"
            >
              {/* Left: Avatar and details */}
              <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flex: 1, minWidth: 0 }}>
                <Skeleton
                  variant="circular"
                  width={48}
                  height={48}
                />
                <Box sx={{ flex: 1, minWidth: 200 }}>
                  <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
                    <Skeleton variant="text" width={120} height={24} />
                    <Skeleton variant="rectangular" width={60} height={20} sx={{ borderRadius: 1 }} />
                  </Stack>
                  <Skeleton variant="text" width="80%" height={20} sx={{ mb: 0.5 }} />
                  <Skeleton variant="text" width="70%" height={20} />
                </Box>
              </Stack>
              
              {/* Middle: Parent details - hidden on mobile */}
              <Stack 
                spacing={0.5} 
                sx={{ 
                  flex: { xs: '1 1 100%', md: '0 0 280px' }, 
                  minWidth: { xs: '100%', md: 240 }, 
                  display: { xs: 'none', md: 'flex' } 
                }}
              >
                <Skeleton variant="text" width="90%" height={20} />
                <Skeleton variant="text" width="85%" height={20} />
                <Skeleton variant="text" width="80%" height={20} />
              </Stack>
              
              {/* Right: Action buttons */}
              <Stack 
                direction="row" 
                spacing={1} 
                alignItems="center" 
                justifyContent="flex-end" 
                sx={{ 
                  flex: { xs: '1 1 100%', md: '0 0 220px' }, 
                  minWidth: { xs: '100%', md: 180 }, 
                  flexWrap: 'wrap', 
                  rowGap: 1 
                }}
              >
                <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: 1 }} />
                <Skeleton variant="rectangular" width={70} height={32} sx={{ borderRadius: 1 }} />
              </Stack>
            </Stack>
          </Paper>
        ))}
      </Box>
    );
  }

  if (variant === 'dashboard') {
    return (
      <Grid container spacing={{ xs: 1.5, sm: 2, md: 3 }}>
        {Array.from({ length: count }).map((_, index) => (
          <Grid item xs={6} sm={6} md={4} lg={4} key={index}>
            <Card
              sx={{
                borderRadius: 2,
                border: 1,
                borderColor: 'divider',
                boxShadow: 2,
                height: '100%',
                transition: 'all 0.2s ease',
              }}
            >
              <CardContent sx={{ p: { xs: 1.5, sm: 2, md: 2.5 } }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 1,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Skeleton 
                      variant="text" 
                      sx={{ 
                        width: 80, 
                        height: { xs: 24, sm: 28, md: 32 },
                        mb: 0.5 
                      }} 
                    />
                    <Skeleton 
                      variant="text" 
                      sx={{ 
                        width: 100, 
                        height: { xs: 12, sm: 14, md: 16 } 
                      }} 
                    />
                  </Box>
                  <Skeleton
                    variant="circular"
                    sx={{
                      width: { xs: 36, sm: 40, md: 44 },
                      height: { xs: 36, sm: 40, md: 44 }
                    }}
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  return null;
};

export default SkeletonLoader;

